import { StyledButton } from 'app/components/Common/CButton/styles'
import styled from 'styled-components'
import { COLORS } from 'app/constants/STYLES'

export const SubDropdownSection = styled.div<{ display?: any }>`
	display: none;
	position: absolute;
	background-color: ${p => p.theme.COLORS.subHeader};
	top: 0px;
	left: 300px;
	width: 300px;
	height: 100%;
	margin-top: 0px;
	-moz-box-shadow: 3px 3px 10px ${p => p.theme.COLORS.shadow};
	-webkit-box-shadow: 3px 3px 10px ${p => p.theme.COLORS.shadow};
	box-shadow: 3px 3px 10px ${p => p.theme.COLORS.shadow};
	border-bottom-right-radius: 10px;
	border-top-right-radius: 10px;
	z-index: 999 !important;
`
// eslint-disable-next-line prettier/prettier
export const DropdownContent = styled.div<{ sizeCheck?: boolean }>`
	display: none;
	position: absolute;
	background-color: ${p => p.theme.COLORS.header};
	top: 100%;
	left: 0;
	margin-top: 4px;
	min-width: 160px;
	border-radius: 8px;
	box-shadow: 0px 8px 24px 0px rgba(0, 0, 0, 0.15);
	z-index: 999 !important;
	padding: 4px 0 !important;
	${({ sizeCheck }) =>
		sizeCheck &&
		`
      &:hover {
        height:500px
       }
    `}
`
export const DropdownList = styled.div`
	padding: 0;
	width: 100%;
	color: #000;
`
export const DropDownContainer = styled.div<{ display?: any }>`
	&:hover ${SubDropdownSection} {
		display: ${props => props.display};
	}
`

export const DropDownSubContainer = styled.div`
	cursor: pointer;
	transition: all 0.15s ease;
	border-radius: 6px;
	margin: 0 4px;

	&:hover {
		background-color: ${p => p.theme.COLORS.point + '15'};
	}
	&:hover ${StyledButton} {
		color: ${p => p.theme.COLORS.point}!important;
	}
`
export const DropDownLeft = styled.div`
	display: flex;
	align-items: flex-start;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`
